import { createActionGroup, emptyProps, props } from '@ngrx/store';

import { EditProfileMutationVariables, JobDetailsV2Fragment, UpdateJobMutationVariables } from '../../../../generated/graphql.generated';
import { ActionSource } from '../../../state/action-sources';
import { CustomerEdit } from '../job-create-customer/job-create-customer.actions';

export const JobFormActionButtonActions = createActionGroup({
	source: ActionSource.JOB_FORM_ACTION_BUTTON,
	events: {
		'Create And Close Job Button Clicked': emptyProps(),
		'Create Job Button Clicked': emptyProps(),
		'Update Job Button Clicked': emptyProps(),
		'Update And Close Job Button Clicked': emptyProps(),
		'Build Update Job Variables Success': props<{
			jobId: string;
			customerChanged: boolean;
			changeIds: string[];
			updateJobVars: UpdateJobMutationVariables;
			customerEdit?: CustomerEdit;
			editProfileVars?: EditProfileMutationVariables;
		}>(),
		'Build Update Job Variables Error': props<{ error: Error }>(),
		'Update Job Success': props<{
			jobId: string;
			updatedJob: JobDetailsV2Fragment;
			changeIds: string[];
			customerEdit?: CustomerEdit;
			locationsChanged: boolean;
		}>(),
		'Update Job Error': props<{
			error: Error;
			changeIds: string[];
		}>(),
		'Create Job Shortcut Entered': emptyProps(),
		'Create And Close Job Shortcut Entered': emptyProps(),
	},
});
